import { useToast } from 'containers/ToastManager'
import { useShareDelete } from 'modules/shares/operations'
import React from 'react'
import Link from 'components/Link'
import { useShareRedirects } from 'modules/shares/routes/useShareRedirects'
import { routes } from 'constants/routes'

interface UseShareDeleteWithUiProps {
  onCompleted?: () => void
}

export const useShareDeleteWithUi = (props: UseShareDeleteWithUiProps = {}) => {
  const { onCompleted } = props
  const { isUserViewing, redirectToDocumentsView } = useShareRedirects()

  const { showToast } = useToast()

  return useShareDelete({
    onCompleted: ({ name, identifier, workspace }) => {
      const workspaceId = workspace.identifier

      showToast(
        <>
          &quot;
          {name}
          &quot; has been moved to{' '}
          <Link
            to={routes.WORKSPACE_TRASH.create({
              workspaceId,
            })}>
            Trash
          </Link>
        </>
      )

      if (isUserViewing.share(identifier)) {
        redirectToDocumentsView({ workspaceId })
      }

      onCompleted?.()
    },
    onError: message => showToast(message, 'negative'),
  })
}
